export const INTERLAYER_CONSTANT = [
    {
        id: 0,
        name: 'Absolute Black PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 1,
        name: 'Acoustical PVB',
        thickness: [
            '.030',
        ]
    },
    {
        id: 2,
        name: 'Arctic Snow PVB Vanceva',
        thickness: [
            '.015',
            '.030',
        ]
    },
    {
        id: 3,
        name: 'Black 50% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 4,
        name: 'Black 78% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 5,
        name: 'Blue 50% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 6,
        name: 'Blue 78% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 7,
        name: 'Clear PVB',
        thickness: [
            '.015',
            '.030',
            '.045',
            '.060',
        ]
    },
    {
        id: 8,
        name: 'Cool White PVB Vanceva',
        thickness: [
            '.015',
            '.030',
        ]
    },
    {
        id: 9,
        name: 'Deep Red PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 10,
        name: 'Ocean Grey PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 11,
        name: 'Polar White 7% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 12,
        name: 'Red 50% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 13,
        name: 'Red 78% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 14,
        name: 'Saflex Storm',
        thickness: [
            '.077',
        ]
    },
    {
        id: 25,
        name: 'Saflex DG41XC',
        thickness: [
            '.030',
        ]
    },
    {
        id: 15,
        name: 'Saflex Storm-AS',
        thickness: [
            '.092',
        ]
    },
    {
        id: 16,
        name: 'Saflex Storm-CW',
        thickness: [
            '.092',
        ]
    },
    {
        id: 17,
        name: 'Saflex Storm-PW',
        thickness: [
            '.092',
        ]
    },
    {
        id: 18,
        name: 'SentryGlas',
        thickness: [
            '.060',
            '.090',
            '.100',
        ]
    },
    {
        id: 19,
        name: 'SentryGlas XTRA',
        thickness: [
            '.030',
            '.050',
            '.100',
        ]
    },
    {
        id: 20,
        name: 'Saflex HP',
        thickness: [
            '.050',
        ]
    },
    {
        id: 21,
        name: 'Tangerine PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 22,
        name: 'True Blue PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 23,
        name: 'Yellow 78% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
    {
        id: 24,
        name: 'Yellow 86% PVB Vanceva',
        thickness: [
            '.015',
        ]
    },
]

export const INTERLAYER_NAME_CONSTANT = [
    'Absolute Black PVB Vanceva',
    'Acoustical PVB',
    'Arctic Snow PVB Vanceva',
    'Black 50% PVB Vanceva',
    'Black 78% PVB Vanceva',
    'Blue 50% PVB Vanceva',
    'Blue 78% PVB Vanceva',
    'Clear PVB',
    'Cool White PVB Vanceva',
    'Deep Red PVB Vanceva',
    'Ocean Grey PVB Vanceva',
    'Polar White 7% PVB Vanceva',
    'Red 50% PVB Vanceva',
    'Red 78% PVB Vanceva',
    'Saflex Storm',
    'Saflex DG41XC',
    'Saflex Storm-AS',
    'Saflex Storm-CW',
    'Saflex Storm-PW',
    'SentryGlas',
    'SentryGlas XTRA',
    'Saflex HP',
    'Tangerine PVB Vanceva',
    'True Blue PVB Vanceva',
    'Yellow 78% PVB Vanceva',
    'Yellow 86% PVB Vanceva',
]

export const SAMPLE_INTERLAYER_CONSTANT = [
    {
        id: 0,
        name: 'Absolute Black PVB Vanceva (G)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 1,
        name: 'Acoustical PVB',
        thickness: [
            '.030',
        ]
    },
    {
        id: 2,
        name: 'Arctic Snow PVB Vanceva (9)',
        thickness: [
            '.015',
            '.030',
        ]
    },
    {
        id: 3,
        name: 'Black 50% PVB Vanceva (7)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 4,
        name: 'Black 78% PVB Vanceva (3)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 5,
        name: 'Blue 50% PVB Vanceva (6)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 6,
        name: 'Blue 78% PVB Vanceva (2)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 7,
        name: 'Clear PVB',
        thickness: [
            '.015',
            '.030',
            '.045',
            '.060',
        ]
    },
    {
        id: 8,
        name: 'Cool White PVB Vanceva (A)',
        thickness: [
            '.015',
            '.030',
        ]
    },
    {
        id: 9,
        name: 'Deep Red PVB Vanceva (C)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 10,
        name: 'Ocean Grey PVB Vanceva (H)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 11,
        name: 'Polar White 7% PVB Vanceva (F)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 12,
        name: 'Red 50% PVB Vanceva (5)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 13,
        name: 'Red 78% PVB Vanceva (1)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 14,
        name: 'Saflex Storm',
        thickness: [
            '.077',
        ]
    },
    {
        id: 15,
        name: 'Saflex Storm-AS',
        thickness: [
            '.092',
        ]
    },
    {
        id: 16,
        name: 'Saflex Storm-CW',
        thickness: [
            '.092',
        ]
    },
    {
        id: 17,
        name: 'Saflex Storm-PW',
        thickness: [
            '.092',
        ]
    },
    {
        id: 18,
        name: 'SentryGlas®',
        thickness: [
            '.060',
            '.090',
            '.100',
        ]
    },
    {
        id: 19,
        name: 'SentryGlas® XTRA',
        thickness: [
            '.030',
            '.050',
            '.100',
        ]
    },
    {
        id: 20,
        name: 'Saflex HP',
        thickness: [
            '.050',
        ]
    },
    {
        id: 38,
        name: 'Saflex DG41XC',
        thickness: [
            '.030',
        ]
    },
    {
        id: 21,
        name: 'Tangerine PVB Vanceva (E)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 22,
        name: 'True Blue PVB Vanceva (D)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 23,
        name: 'Yellow 78% PVB Vanceva (4)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 24,
        name: 'Yellow 86% PVB Vanceva (8)',
        thickness: [
            '.015',
        ]
    },
    {
        id: 25,
        name: 'Blue-Green 73% PVB 377300',
        thickness: [
            '.030',
        ]
    },
    {
        id: 26,
        name: 'blue-green PVB 377300',
        thickness: [
            '.015',
        ]
    },
    {
        id: 27,
        name: 'bronze 28% PVB 642800',
        thickness: [
            '.015',
        ]
    },
    {
        id: 28,
        name: 'bronze 52% PVB 645200',
        thickness: [
            '.015',
            '.030',
        ]
    },
    {
        id: 29,
        name: 'brown 28% PVB 362800',
        thickness: [
            '.015',
        ]
    },
    {
        id: 30,
        name: 'brown 9% PVB 360900',
        thickness: [
            '.015',
        ]
    },
    {
        id: 31,
        name: 'clear PVB RA41',
        thickness: [
            '.030',
        ]
    },
    {
        id: 32,
        name: 'clear PVB RA61',
        thickness: [
            '.045',
        ]
    },
    {
        id: 33,
        name: 'clear PVB RA71',
        thickness: [
            '.060',
        ]
    },
    {
        id: 34,
        name: 'clear PVB RB11',
        thickness: [
            '.015',
        ]
    },
    {
        id: 35,
        name: 'Trosifol® Clear B500JR',
        thickness: [
            '.030',
            '.045',
            '.060',
        ]
    },
    {
        id: 36,
        name: 'Trosifol® UltraClear B200NR',
        thickness: [
            '.030',
            '.060',
        ]
    },
    {
        id: 37,
        name: 'SentryGlas XTRA',
        thickness: [
            '.030',
            '.050',
            '.100',
        ]
    }
]

export const SAMPLE_INTERLAYER_NAME_CONSTANT = [
    'Absolute Black PVB Vanceva (G)',
    'Acoustical PVB',
    'Arctic Snow PVB Vanceva (9)',
    'Black 50% PVB Vanceva (7)',
    'Black 78% PVB Vanceva (3)',
    'Blue 50% PVB Vanceva (6)',
    'Blue 78% PVB Vanceva (2)',
    'Clear PVB',
    'Cool White PVB Vanceva (A)',
    'Deep Red PVB Vanceva (C)',
    'Ocean Grey PVB Vanceva (H)',
    'Polar White 7% PVB Vanceva (F)',
    'Red 50% PVB Vanceva (5)',
    'Red 78% PVB Vanceva (1)',
    'Saflex Storm',
    'Saflex Storm-AS',
    'Saflex Storm-CW',
    'Saflex Storm-PW',
    'SentryGlas®',
    'SentryGlas® XTRA',
    'Saflex HP',
    'Saflex DG41XC',
    'Tangerine PVB Vanceva (E)',
    'True Blue PVB Vanceva (D)',
    'Yellow 78% PVB Vanceva (4)',
    'Yellow 86% PVB Vanceva (8)',
    'Blue-Green 73% PVB 377300',
    'blue-green PVB 377300',
    'bronze 28% PVB 642800',
    'bronze 52% PVB 645200',
    'brown 28% PVB 362800',
    'brown 9% PVB 360900',
    'clear PVB RA41',
    'clear PVB RA61',
    'clear PVB RA71',
    'clear PVB RB11',
    'Trosifol® Clear B500JR',
    'Trosifol® UltraClear B200NR',
    'SentryGlas XTRA'
];

